import logo from './logo.svg';
import './App.css';
import React from 'react';
import Anime from 'react-anime';
import img1 from './imgs/i1.png';
import img2 from './imgs/i2.png';
import img3 from './imgs/i3.png';
import img4 from './imgs/i4.png';
import img5 from './imgs/i5.png';
import img6 from './imgs/i6.png';

import img11 from './imgs/secondrow/i1.png';
import img22 from './imgs/secondrow/i2.png';
import img33 from './imgs/secondrow/i3.png';
import img44 from './imgs/secondrow/i4.png';
import img55 from './imgs/secondrow/i5.png';
import img66 from './imgs/secondrow/i6.png';

import icon1 from './imgs/icon1.svg';
import icon2 from './imgs/icon2.svg';
import icon3 from './imgs/icon3.svg';
import icon4 from './imgs/icon4.svg';
import icon5 from './imgs/icon5.svg';
import okicon from './imgs/ok.svg';
import teamicon from './imgs/teamwork.png';
import suppicon from './imgs/suppicon.svg';
import mbicon from './imgs/mbicon.svg';
import copyi from './imgs/copyicon.png';
import simpleicon from './imgs/simpleicon.svg';
import vline from './imgs/lineicon.svg';
import Slider from './slider';
import anime from 'animejs/lib/anime.es.js';
import Checkbox from './checkbox';
import emailjs from 'emailjs-com';
import{ init } from 'emailjs-com';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

class App extends React.Component {

  constructor(props) {
    super(props);  
    this.state = {
      currDrop: 'Candy Store?',
      currDrop2: '{Boring Stuff List}',
      dur: 1,
      submitted: false,
      loading: false
    }
  }

clicked = (event) => {
  let newDrop = event.target.innerText;
  let durPlus = new Number(event.target.attributes.value.value) + 1;
  console.log(durPlus);

  [ ...document.getElementsByClassName("dropdown-item") ].forEach( x => x.classList.remove('d-none') )
  document.getElementById(newDrop).classList.add('d-none');

  this.setState({
      currDrop: newDrop,
      dur: durPlus
  })
 
}

clicked2 = (event) => {
  let newDrop = event.target.innerText;

  [ ...document.getElementsByClassName("dropdown-item") ].forEach( x => x.classList.remove('d-none') )
  document.getElementById(newDrop).classList.add('d-none');

  this.setState({
      currDrop2: newDrop
  })
 
}

componentDidMount() {
  
  let yesdrop = document.getElementById('yes-dropdown');
  yesdrop.classList.add('z-high');
  
}

yepClicked = () => {
  let yepbtn = document.getElementById('yep-btnn');
  let nopebtn = document.getElementById('nope-btnn');
  nopebtn.classList.remove('btnn-active');
  yepbtn.classList.add('btnn-active');
  anime({
    targets: '#yes-dropdown',
    bottom: '0',
    marginBottom: '2rem',
    color: '#FFF',
    easing: 'easeInOutCirc',
    duration: 700,
    loopComplete: function() {
      let yesdrop = document.getElementById('yes-dropdown');
      yesdrop.classList.add('z-high');
    }
  });

 
}

nopeClicked = () => {
  let yepbtn = document.getElementById('yep-btnn');
  let nopebtn = document.getElementById('nope-btnn');
  let yesdrop = document.getElementById('yes-dropdown');
  yesdrop.classList.remove('z-high');
  yepbtn.classList.remove('btnn-active');
  nopebtn.classList.add('btnn-active');
  anime({
    targets: '#yes-dropdown',
    bottom: '5rem',
    marginBottom: '-2rem',
    color: '#FFF',
    easing: 'easeInOutCirc',
    duration: 700,
    loopComplete: function() {
      let yesdrop = document.getElementById('yes-dropdown');
      yesdrop.classList.remove('z-high');
    }
  });
  
}

sendMessage = () => {
  if(this.state.submitted == false){
    this.setState({
      loading: true
    })
  }
  
  if(this.state.submitted == false){
    let email = document.getElementById('email').value;
    let messa = document.getElementById('message').value;
    let coding = document.getElementById('coding').checked;
    let des = document.getElementById('design').checked;
    let drop1 = document.getElementById('dropdown1').innerHTML;
    let drop2 = document.getElementById('dropdown2').innerHTML;
    let budget = document.getElementById('budget').textContent;
    console.log(budget);
  
  
  
    init("user_NGCLNUURlBx8CHWpVuX2L");
  
    var templateParams = {
      from_name: email,
      willCode: coding,
      willDesign: des,
      budget: budget,
      typeOfSite: drop1,
      tech: drop2,
      message: messa
  };
   
  emailjs.send('service_7vczzvh', 'template_ig3a6gs', templateParams)
      .then((response) => {
         console.log('SUCCESS!', response.status, response.text);
         this.setState({
           submitted: true,
           loading: false
         })
      }, function(error) {
         console.log('FAILED...', error);
      });
  }
  else{
    console.log('you have already sent a message if you want to further contact mr moe send a dm to his telegram :)')
  }
 
}

render() {
  let submitarea
  if(this.state.loading == true){
    submitarea = <Loader
    type="Oval"
    color="#ffffff"
    height={25}
    width={25}
  />
  }
  else{
    submitarea = this.state.submitted ? <div>SUBMITTED <img style={{ width: '25px', height: '25px', color: 'white' }} src={okicon}></img></div> : "SUBMIT";
  }
   
  return (
    <div className="selector">
        <div className="header py-5">
          <h3>Moe</h3>
        </div>
        <h4 className='text-center' style={{fontWeight: "300", fontSize: '30px', lineHeight: "175%", margin: '5rem 0 5rem 0'}}>
        I’m a Web Dev + Designer, <br></br>
        and I like to keep it simple :)
        </h4>
        <div className='container'>
        <h4 className="text-center" style={{fontWeight: '700', letterSpacing: '2%', fontSize: '30px', color: 'white', margin: '3rem 0 3rem 0'}}>Here's some of my work</h4>
        </div>
        <div style={{ marginBottom: '45vw' }}>
        <div className='d-flex text-white'>
            <Anime easing="linear"
            duration={25000}
            direction="normal"
            loop={true}
            translateX='198vw'
            >
              <div className="portfolio-img" style={{width: '30vw', margin: '1vw', left: "-198vw", position: 'absolute'}}><img style={{width: '30vw', margin: '1vw'}} src={img4}></img></div>
            <div className="portfolio-img" style={{width: '30vw', margin: '1vw', left: "-165vw", position: 'absolute'}}><img style={{width: '30vw', margin: '1vw'}} src={img5}></img></div>
            <div className="portfolio-img" style={{width: '30vw', margin: '1vw', left: "-132vw", position: 'absolute'}}><img style={{width: '30vw', margin: '1vw'}} src={img6}></img></div>

            <div className="portfolio-img" style={{width: '30vw', margin: '1vw', left: "-99vw", position: 'absolute'}}><img style={{width: '30vw', margin: '1vw'}} src={img1}></img></div>
            <div className="portfolio-img" style={{width: '30vw', margin: '1vw', left: "-66vw", position: 'absolute'}}><img style={{width: '30vw', margin: '1vw'}} src={img2}></img></div>
            <div className="portfolio-img" style={{width: '30vw', margin: '1vw', left: "-33vw", position: 'absolute'}}><img style={{width: '30vw', margin: '1vw'}} src={img3}></img></div>
            <div className="portfolio-img" style={{width: '30vw', margin: '1vw', left: "0", position: 'absolute'}}><img style={{width: '30vw', margin: '1vw'}} src={img4}></img></div>
            <div className="portfolio-img" style={{width: '30vw', margin: '1vw', left: "33vw", position: 'absolute'}}><img style={{width: '30vw', margin: '1vw'}} src={img5}></img></div>
            <div className="portfolio-img" style={{width: '30vw', margin: '1vw', left: "66vw", position: 'absolute'}}><img style={{width: '30vw', margin: '1vw'}} src={img6}></img></div>
          </Anime>
        </div>
        <div className='d-flex text-white' style={{margin: '33vw 0'}}>
            <Anime easing="linear"
            duration={25000}
            direction="reverse"
            loop={true}
            translateX='198vw'
            >
              <div className="portfolio-img" style={{width: '30vw', margin: '1vh', left: "-198vw", position: 'absolute'}}><img style={{width: '30vw', margin: '1vh'}} src={img44}></img></div>
            <div className="portfolio-img" style={{width: '30vw', margin: '1vh', left: "-165vw", position: 'absolute'}}><img style={{width: '30vw', margin: '1vh'}} src={img55}></img></div>
            <div className="portfolio-img" style={{width: '30vw', margin: '1vh', left: "-132vw", position: 'absolute'}}><img style={{width: '30vw', margin: '1vh'}} src={img66}></img></div>

            <div className="portfolio-img" style={{width: '30vw', margin: '1vh', left: "-99vw", position: 'absolute'}}><img style={{width: '30vw', margin: '1vh'}} src={img11}></img></div>
            <div className="portfolio-img" style={{width: '30vw', margin: '1vh', left: "-66vw", position: 'absolute'}}><img style={{width: '30vw', margin: '1vh'}} src={img22}></img></div>
            <div className="portfolio-img" style={{width: '30vw', margin: '1vh', left: "-33vw", position: 'absolute'}}><img style={{width: '30vw', margin: '1vh'}} src={img33}></img></div>
            <div className="portfolio-img" style={{width: '30vw', margin: '1vh', left: "0", position: 'absolute'}}><img style={{width: '30vw', margin: '1vh'}} src={img44}></img></div>
            <div className="portfolio-img" style={{width: '30vw', margin: '1vh', left: "33vw", position: 'absolute'}}><img style={{width: '30vw', margin: '1vh'}} src={img55}></img></div>
            <div className="portfolio-img" style={{width: '30vw', margin: '1vh', left: "66vw", position: 'absolute'}}><img style={{width: '30vw', margin: '1vh'}} src={img66}></img></div>
          </Anime>
        </div>
        </div>
        
        <div className='container'>
        <h4 className="text-center" style={{fontWeight: '700', letterSpacing: '2%', fontSize: '30px', color: 'white', margin: '3rem 0 3rem 0'}}>What do I do?</h4>
          <div className='text-white row' style={{ fontSize: '20px' }}>
            <div className='col-1 col-md-3'></div>
            <div className='col-10 col-md-6'>
              <p className='mb-4'>I do everything related to <strong> web development including designing.</strong></p>
              <p className='mb-4'>Frontend, Backend languages (HTML, CSS, JS, PHP, NodeJS, SQL, Mongo, etc) and their technologies (Laravel, Express, React, Bootstrap).</p>
              <p><strong>Can also work with </strong>Wordpress, Squarespace, Shopify, Wix, Databases, AWS and all kinds of hosting platforms and website builders.</p>
            </div>
            <div className='col-1 col-md-3'></div>
          </div>
          {/* SECTION 2 */}
          <h4 className="text-center" style={{fontWeight: '700', letterSpacing: '2%', fontSize: '30px', color: 'white', margin: '6rem 0 1rem 0'}}>How do you build a site?</h4>
          <p className='text-center mb-5 text-black' style={{fontSize: '20px'}}><strong>As I said, I like it simple!</strong></p>

          <div className='row justify-content-center'>
            
            <div className='mb-5 col-10 col-md-4 align-content-center justify-content-center'>
              <div className='d-flex'>
                <img style={{ width: '50px', marginRight: '20px' }} src={icon1}></img>
                <p>We start off with brainstorming ideas and designing a prototype for the website.</p>
              </div>
            </div>
            
            <div className='mb-5 col-10 col-md-4 d-flex align-content-center justify-content-center'>
              <img style={{ width: '50px', marginRight: '20px' }} src={icon2}></img>
              <p>then we discuss which technologies to use to actually build the site.</p>
            </div>
            
          </div>
          

          <div className='row justify-content-center'>
            
            <div className='mb-5 col-10 col-md-4 d-flex align-content-center justify-content-center'>
              <img style={{ width: '50px', marginRight: '20px' }} src={icon3}></img>
              <p>Then we start coding the frontend of the site and start seeing actual progress in the browser.</p>
            </div>
            
            <div className='mb-5 col-10 col-md-4 d-flex align-content-center justify-content-center'>
              <img style={{ width: '50px', marginRight: '20px' }} src={icon4}></img>
              <p>Then we start working on the backend and the functionality aspect of the site.</p>
            </div>
            
            
          </div>
          <div className='d-flex mb-3 flex-column'>
            <img className='mb-4' style={{ width: '3px', margin: '0 auto' }} src={vline}></img>
            <div className='row'>
              <div className="col-1 col-md-3"></div>
                <div className='col-10 col-md-6'>
                  <p style={{ fontSize: '20px' }} className='text-center mb-4'><strong>Finally we do final revisions, publish the site and deploy it on a hosting provider.</strong></p>
                </div>
              <div className="col-1 col-md-3"></div>
            </div>
            <img style={{ width: '50px', margin: '0 auto' }} src={icon5}></img>
          </div>

         {/* SECTION 3 */}

         <h4 className="text-center" style={{fontWeight: '700', letterSpacing: '2%', fontSize: '30px', color: 'white', margin: '6rem 0 2rem 0'}}>Why you?</h4>
          <div className='row'>
            <div className='col-1 col-md-3'></div>
              <div className='col-10 col-md-6 d-flex align-items-center justify-content-center mb-5'>
                <img style={{ width: '50px', marginRight: '25px' }} src={simpleicon}></img>
                <p><strong>Simplicity</strong> while designing and coding is <strong>my main priority</strong> which ensures a clean quality user experience.</p>
              </div>
            <div className='col-1 col-md-3'></div>
            <div className='col-1 col-md-3'></div>
              <div className='col-10 col-md-6 d-flex align-items-center justify-content-center mb-5'>
                <img style={{ width: '50px', marginRight: '25px' }} src={suppicon}></img>
                <p><strong>24/7  fulltime  support  for  a  year</strong> after I deliver your product. Always offered <strong>for free</strong> because <strong>it’s your right!</strong></p>
              </div>
            <div className='col-1 col-md-3'></div>
            <div className='col-1 col-md-3'></div>
              <div className='col-10 col-md-6 d-flex align-items-center justify-content-center mb-5'>
                <img style={{ width: '50px', marginRight: '25px' }} src={mbicon}></img>
                <p><strong>Money Back gurantee </strong> for a whole month starting on deploying the web app to prove <strong>credibility</strong> and <strong>honesty</strong>.</p>
              </div>
            <div className='col-1 col-md-3'></div>
            <div className='col-1 col-md-3'></div>
            <div className='col-10 col-md-6 d-flex align-items-center justify-content-center mb-5'>
                <img style={{ width: '50px', height: '50px', marginRight: '25px' }} src={teamicon}></img>
                <p><strong>Did I mention that I'm not working alone?</strong> We are a team of web developers and designers that always strive to deliver the best results ASAP!</p>
              </div>
            <div className='col-1 col-md-3'></div>
          </div>
          <div className='row'>
              <div className="col-1 col-md-3"></div>
                <div className='col-10 col-md-6'>
                  <p style={{ fontSize: '20px' }} className='text-center mb-4'><strong>Basically, We will never deliver a product unless you’re fully satisfied with the results.</strong></p>
                  <p style={{ fontSize: '22px' }} className='text-center mb-4 text-dark'><strong>Simple as that :)</strong></p>
                </div>
              <div className="col-1 col-md-3"></div>
            </div>

            {/* SECTION 4 */}
            <h4 className="text-center" style={{fontWeight: '700', letterSpacing: '2%', fontSize: '30px', color: 'white', margin: '6rem 0 2rem 0'}}>How much do you charge?<br></br>
            How long does it take?</h4>
            <p className='text-center mb-5' style={{fontSize: '23px', color: '#191308'}}><strong>It depends</strong></p>
            <p className='text-center mb-5 text-white' style={{fontSize: '23px', color: '#191308'}}>First choose your budget range</p>
            
            <Slider style={{ cursor:'pointer' }}/>
            
            <p className='text-center mb-5 text-white' style={{fontSize: '23px', color: '#191308'}}>What kind of website are <br></br>you creating?</p>

            <div className='row mb-5 justify-content-center'>
              <div className='col-10 col-md-6 col-lg-4 d-flex justify-content-center'>
                  <div className="dropdown w-100">
                  <button className="btn btn-secondary dropdown-toggle dropdownmenu" type="button" id="dropdown1" data-bs-toggle="dropdown" aria-expanded="false">
                    {this.state.currDrop}
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    <li><a id='eCommerce' value='2' className="dropdown-item" onClick={this.clicked} >eCommerce</a></li>
                    <li><a id='Portfolio' value='0' className="dropdown-item" onClick={this.clicked}>Portfolio</a></li>
                    <li><a id='Personal Website' value='0' className="dropdown-item" onClick={this.clicked}>Personal Website</a></li>
                    <li><a id='Advanced Web App' value='2' className="dropdown-item" onClick={this.clicked}>Advanced Web App</a></li>
                    <li><a id='Social Platform' value='2' className="dropdown-item" onClick={this.clicked}>Social Platform</a></li>
                    <li><a id='Online Game' value='3'className="dropdown-item" onClick={this.clicked}>Online Game</a></li>
                    <li><a id='Other (Please specify below)' value='0' className="dropdown-item" onClick={this.clicked}>Other (Please specify below)</a></li>
                  </ul>
                </div>
              </div>
          </div>
          
          <div className='row justify-content-center pb-5'>
            <div className='col-10 col-md-6 col-lg-4'>
            <p className='text-center mb-5 text-white' style={{fontSize: '23px', color: '#191308'}}>What services are you<br></br> looking for?</p>
            <div className='row no-select'>
              <div className='col-6 d-flex justify-content-center'>
                
                <div className="form-check">
                <Checkbox id='design'/>
                <label style={{ fontSize: '18px' }} className="form-check-label p-pointer text-white" for="design">
                  Designing
                </label>
              </div>
              </div>
              <div className='col-6 d-flex justify-content-center'>
              <div className="form-check">
                <Checkbox id='coding'/>
                <label style={{ fontSize: '18px' }} className="form-check-label p-pointer text-white" for="coding">
                  Coding
                </label>
              </div>
              </div>
            </div>
            </div>

          </div>

          <div className='row justify-content-center'>
            <div className='col-10 col-md-6 col-lg-4 d-flex flex-column justify-content-center'>
            <p className='text-center pb-5 text-white selector z-high' style={{fontSize: '23px', color: '#191308'}}>Do you prefer certain <br></br>technologies than others? </p>

            <div className='row justify-content-center'>
              <div style={{ zIndex: '2' }} className='col-6 selector text-center'>
                <button id='yep-btnn' className='btnn btnn-active' onClick={this.yepClicked}>Yep</button>
              </div>

              <div style={{ zIndex: '2' }} className='col-6 selector text-center'>
                <button id='nope-btnn' className='btnn' onClick={this.nopeClicked}>Nope</button>
              </div>
            
              <div className='col-12 mt-3'>
              <div id='yes-dropdown' style={{ zIndex: '1', marginBottom: '1.5rem' }} className="dropdown w-100 mt-3 d-flex justify-content-center">
                  <button className="btn btn-secondary dropdown-toggle dropdownmenu" type="button" id="dropdown2" data-bs-toggle="dropdown" aria-expanded="false">
                    {this.state.currDrop2}
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    <li><a id='React' className="dropdown-item" onClick={this.clicked2} >React</a></li>
                    <li><a id='Wordpress' className="dropdown-item" onClick={this.clicked2}>Wordpress</a></li>
                    <li><a id='Vue' className="dropdown-item" onClick={this.clicked2}>Vue</a></li>
                    <li><a id='Laravel' className="dropdown-item" onClick={this.clicked2}>Laravel</a></li>
                    <li><a id='Wix' className="dropdown-item" onClick={this.clicked2}>Wix</a></li>
                    <li><a id='Shopify' className="dropdown-item" onClick={this.clicked2}>Shopify</a></li>
                    <li><a id='Squarespace' className="dropdown-item" onClick={this.clicked2}>Squarespace</a></li>
                    <li><a id='Other' className="dropdown-item" onClick={this.clicked2}>Other</a></li>
                  </ul>
                </div>
              </div>
            </div>
            </div>


          
          </div>
          <div className='row justify-content-center mb-3'>
            <div className='col-10 col-md-6 col-lg-4'>
              <h1 style={{ color: 'white', background: '#F77457', borderRadius: '20px', padding: '1rem 3rem', fontSize: '15px' }} className='text-center box-shadow mb-3 mt-3'> Project Duration: <strong>{this.state.dur} - {this.state.dur + 1} Months</strong>
              <br>
              </br>
              <span className='text-white' style={{ fontSize: '10px' }}>Approx.</span>
              </h1>
              <span>
                <p className='text-center' style={{ fontSize: '11px' }}>This is an automated message and duration may vary, please contact me below and share your project ideas with me and I’ll be in touch ASAP
                <br/>
                <strong>Note: The information you filled above will be included.</strong></p>
              </span>
              
            </div>

          </div>
          <div className='row justify-content-center'>
              <div className='col-10 col-md-6 col-lg-4 d-flex justify-content-center flex-column'>
                <input id='email' className='p-2 mb-4' style={{ borderRadius: '20px', background: 'transparent', border: '3px solid white' }} type='email' placeholder='Email'></input>
                <textarea id='message' className='mb-4 p-3' style={{ borderRadius: '20px', background: 'transparent', border: '3px solid white', height: '30vh' }} type='text' placeholder='DETAILS'></textarea>
                <button onClick={this.sendMessage} className='w-100 p-2 text-white box-shadow' style={{ borderRadius: '20px', background: '#F77457', letterSpacing: '5px' }}>
                {submitarea}
                </button>
              </div>
          </div>  
          <br></br>
        <p className='text-center'>Or just contact me on</p>
        <br></br>
        <p className='text-center mb-3'>Telegram: <strong>@moeayman03</strong> <button 
  onClick={() =>  navigator.clipboard.writeText('@moeayman03')} > <img className='copy-btn' src={copyi}></img> </button> </p>
         <p className='text-center mb-3'>Discord: <strong>Mlotov#4999</strong> <button 
  onClick={() =>  navigator.clipboard.writeText('Mlotov#4999')}
>
  <img className='copy-btn' src={copyi}></img>
</button></p>
         <p className='text-center mb-3'>Email: <strong>moeayman03@hotmail.com</strong> <button 
  onClick={() =>  navigator.clipboard.writeText('moeayman03@hotmail.com')}
>
<img className='copy-btn' src={copyi}></img>
</button> </p>
<br/> 
<hr />
<br/> 
      <p className='text-center'>Designed and coded by <span style={{ fontFamily: 'pacifico' }}>Moe</span> :)</p>
      <br/> <br/>
        </div>
        
      
    </div>
   
  );
}
}
export default App;
